<template>
	<div class="query">
		<!-- 公共头 start -->
		<Header></Header>
		<!-- 公共头 end -->

		<div class="container bg-white padd m-mt20" style="min-height: 600px;">
			<div class="column-banner">
				<h2>信息查询</h2>
			</div>
			<div class="xxcxmain clearfix">
				<div class="slidexxcx">
					<div class="slidexxcxs">
						<h2>
							信息查询
							<span>QUERY</span>
						</h2>
						<div class="slides">
							<p :class="isShowItem == 1 ? 'slidesn factive' : 'slidesn'" @click="isShowItem == 1 ? (isShowItem = -1) : (isShowItem = 1)">成绩查询</p>
							<div :class="isShowItem == 1 ? 'slidenav active' : 'slidenav'" v-if="isShowItem == 1">
								<!-- <a>全国卫生专业技术资格考试（中初级）</a>
								<a>护士执业资格考试</a>
								<a>高级卫生专业技术资格考试</a>
								<a>技能人才评价</a>
								<a>住院医师规范化培训考核</a>
								<a>招聘及其他类型考试</a> -->
							</div>
						</div>
						<div class="slides">
							<p :class="isShowItem == 2 ? 'slidesn factive' : 'slidesn'" @click="isShowItem == 2 ? (isShowItem = -1) : (isShowItem = 2)">证书查询</p>
							<div :class="isShowItem == 2 ? 'slidenav active' : 'slidenav'" v-if="isShowItem == 2">
								<a :class="itemClick == index ? 'factive' : ''" @click="(title = item), (itemClick = index)" v-for="(item, index) in queryCertList" :key="index">{{ item }}</a>
							</div>
						</div>
						<!-- <div class="slides">
							<p class="slidesnone"><a>人事档案查询</a></p>
						</div>
						<div class="slides">
							<p class="slidesnone"><a>涉外专业技术人员资格认定查询</a></p>
						</div> -->
					</div>
				</div>
				<div class="xxcxlist" v-if="itemClick != -1">
					<div class="channeln">
						<p>{{ title }}</p>
					</div>
					<div class="query_form">
						<div>
							<el-form ref="form" :model="form">
								<el-form-item class="form_item" label="" v-if="title != '2024年以前证书查询'">
									<el-input v-model="form.certTo" placeholder="请输入单位名称"></el-input>
								</el-form-item>
								<el-form-item class="form_item" label="">
									<el-input v-model="form.certNo" placeholder="请输入证书编码"></el-input>
								</el-form-item>
								<el-form-item class="form_item">
									<div class="query_btn" @click="getCert()">查&nbsp;&nbsp;询</div>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog title="查询结果" :visible.sync="dialogVisible" width="30%">
			<div>{{ queryRes.certTo }}</div>
			<div>证书编号：{{ queryRes.certNo }}</div>
			<div>颁发内容{{ queryRes.issueContent }}</div>
			<span slot="footer" class="dialog-footer">
				<div class="query_btn" @click="dialogVisible = false">确&nbsp;&nbsp;定</div>
			</span>
		</el-dialog>

		<!-- 公共尾 start -->
		<Footer></Footer>
		<!-- 公共尾 end -->
	</div>
</template>

<script>
import Header from '@/components/header';
import Footer from '@/components/footer';
export default {
	components: {
		Header,
		Footer
	},
	name: 'Query',
	data() {
		return {
			dialogVisible: false,
			form: {
				certTo: '',
				certNo: ''
			},
			title: '',
			isShowItem: -1,
			queryCertList: ['2024年以前证书查询','学会会员单位授牌证书查询', '学会编册会员证书', '角膜塑形镜验配师证书查询', '角膜塑形镜咨询师证书查询'],
			itemClick: -1,
			queryRes: {}
		};
	},
	mounted() {},
	methods: {
		getCert() {
			this.req({
				url: '/system/cert/list',
				params: this.form,
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.queryRes = res.rows[0];
					this.dialogVisible = true;
				}
			});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../assets/query/common.css"></style>
<style scoped src="../assets/query/xxcx.css"></style>
<style scoped src="../assets/query/lists.css"></style>
<style lang="scss" scoped>
.query_form {
	width: 400px;
	margin: 0 auto;
	.form_item {
		margin: 20px 0 0 0;
	}
}
.query_btn {
	width: 120px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	background: #409eff;
	border-radius: 4px;
	color: #ffffff;
	border: 1px solid #eeeeee;
	margin: 0 auto;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/query.vue